import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { SaveLayerDialogService, SaveLayerParams } from './save-layer-dialog-service';

import { SLLayer } from 'src/app/model/sl-layer';
import { LayerSaveOptions } from 'src/app/model/api-services/layer-api.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';

@Component({
	selector: 'app-save-layer-dialog',
	templateUrl: './save-layer-dialog.component.html',
	styleUrls: ['./save-layer-dialog.component.scss']
})
export class SaveLayerDialogComponent implements OnInit {
	public title = 'Save Layer';
	public options: LayerSaveOptions = {
		target: 'player',
		properties: true,
		classification: true,
		labelStyle: true,
		tooltip_rich: true,
		tooltip: false
	};
	private layer: SLLayer;

	@HostBinding('class.work-view') workView = true;

	constructor(private activeModal: NgbActiveModal, private messager: ModalMessagerService) { }

	ngOnInit() {
	}
	Show(params: SaveLayerParams) {
		this.layer = params.layer;
	}
	Save() {
		const progMessage = 'saving layer ' + this.layer.name;
		this.messager.Progress(progMessage, false, 50, 'Saving ...');
		this.layer.Save(this.options).then((response) => {
			if (response.status === 'ok') {
				this.messager.Progress(progMessage, true, 100, 'Saving...');
			} else {
				this.messager.Progress(progMessage, true, 100, 'Saving...');
				this.messager.CancelProgress(progMessage);
				this.messager.Notify('There was a problem saving this layer');
			}
		});
	}
	SaveAsDefault() {

	}
	Cancel() {
		this.activeModal.close();
	}

}

@Component({
	selector: 'app-save-layer-dialog-entry',
	template: ''
})
export class SaveLayerDialogEntryComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: SaveLayerDialogService) {

		this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
			this.modalRef = this.modalService.open(SaveLayerDialogComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as SaveLayerDialogComponent).Show(info);
		});
	}
	ngOnDestroy(): void {
		this.subscriptionMgr.CancelSubscriptions();
	}
}
